import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { PreviewType } from '../block.js'
import { TextOrCode } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

export const IconBlockFontSets = {
	'material-icons': 'Filled',
	'material-icons-outlined': 'Outlined',
} as const
export type IconBlockFontSet = keyof typeof IconBlockFontSets

@jsonClass('IconBlock')
export class IconBlock extends LeafBlock {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Icon name',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
		spanColumns: 'span 2',
	})
	textCode = new TextOrExpression_assumeExpression('delete', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 2,
		label: 'Icon style',
		options: Object.entries(IconBlockFontSets),
	})
	fontSet: IconBlockFontSet = 'material-icons'

	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 3,
		label: 'Inline',
	})
	@jsonProperty(Boolean)
	inline: boolean = false

	constructor(init: Partial<IconBlock> = {}) {
		super()
		this.init(init)
	}

	producePreview(): PreviewType {
		let fontIcon = this.textCode.content?.match(/^\s*(['"]?)(?<icon>.*)\1$/)
			?.groups?.icon
		if (!fontIcon) {
			fontIcon = 'question_mark'
		}
		return {
			type: 'icon',
			fontIcon,
			fontSet: this.fontSet,
		}
	}

	getEditorCategory(): string {
		return 'Core'
	}
}
